module.exports = __webpack_public_path__ + "img/3002gray.bb490449.svg";